import React from "react";

// import { useUserContext } from "../context/userContext";

import MainScreen from "../components/MainScreen/Components/MainScreen.js";

const Dashboard = () => {
  // const { user, logoutUser } = useUserContext();
  return (
    <>
      <MainScreen />
    </>
  );
};

export default Dashboard;

/* // <h2>Name : {user.displayName}</h2>
      // <h2>Email : {user.email}</h2> */
